const apikeymap={
    apikey:"AIzaSyCg8hzjyIYLA4m0qUfuJIMJH29fP9v3v1Q"
}

export default apikeymap